/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_AccountInputs */



/**
* | output |
* | --- |
* | "Manage Account" |
*
* @param {Manage_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manage_account = /** @type {((inputs?: Manage_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer le compte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konto verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci account")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление учетной записью")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrar cuenta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理账户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アカウント管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाते का प्रबंधन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciar conta")
	return /** @type {LocalizedString} */ ("Manage Account")
});